import React from 'react';
import { Group } from '../services/groupService';

interface FilterBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedParentGroup: string;
  onParentGroupChange: (value: string) => void;
  selectedGroup: string;
  onGroupChange: (value: string) => void;
  selectedDate: string;
  onDateChange: (value: string) => void;
  parentGroups: Group[];
  groups: Group[];
  onRefresh: () => void;
  onExport: () => void;
  groupByDescription: boolean;
  onGroupByDescriptionChange: (value: boolean) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  searchTerm,
  onSearchChange,
  selectedParentGroup,
  onParentGroupChange,
  selectedGroup,
  onGroupChange,
  selectedDate,
  onDateChange,
  parentGroups,
  groups,
  onRefresh,
  onExport,
  groupByDescription,
  onGroupByDescriptionChange,
}) => {
  return (
    <div className="controls">
      <div className="filter-bar">
        <div className="search-box">
          <input
            type="text"
            placeholder="🔍 Açıklama ara..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>

        <div className="filter-group">
          <select
            className="filter-select"
            value={selectedParentGroup}
            onChange={(e) => onParentGroupChange(e.target.value)}
          >
            <option value="">Tüm Üst Gruplar</option>
            {parentGroups.map((group) => (
              <option key={group._id || group.name} value={group.name}>
                {group.name}
              </option>
            ))}
          </select>

          <select
            className="filter-select"
            value={selectedGroup}
            onChange={(e) => onGroupChange(e.target.value)}
          >
            <option value="">Tüm Gruplar</option>
            {groups.map((group) => (
              <option key={group._id || group.name} value={group.name}>
                {group.name}
              </option>
            ))}
          </select>

          <input
            type="date"
            className="filter-input"
            value={selectedDate}
            onChange={(e) => onDateChange(e.target.value)}
          />
        </div>

        <div className="filter-actions">
          <button
            type="button"
            className={`btn btn-toggle-group${groupByDescription ? ' active' : ''}`}
            onClick={() => onGroupByDescriptionChange(!groupByDescription)}
          >
            {groupByDescription ? 'Açıklama Gruplama Aktif' : 'Açıklamaya Göre Grupla'}
          </button>

          <div className="action-buttons">
            <button className="btn btn-primary" onClick={onRefresh}>
              🔄 Yenile
            </button>
            <button className="btn btn-secondary" onClick={onExport}>
              📥 CSV İndir
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;

